import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DocumentTemplate from "./DocumentTemplate";
import RequestFormTemplate from "./RequestFormTemplate";
import {
	getTemplateEnvelope, getTemplateUser,
	templateEnvelopeModify,
	templateFolderBreadcrumbs
} from "../../../../../services/Templates";
import { toast } from "react-toastify";
import Utils from "../../../../../utils";
import { getEnvelopeDocumentCheckStorage, getPreferenceData, postCloudList } from "../../../../../services/CommonService";
import {
	NAME_CONVENTION,
	OVERDUE_REMINDER,
	PASSWORD_LIST,
	SEND_REMINDER,
	SYNC_STATUS
} from "../../../../../configs/AppConfig";
import { Lang } from "../../../../../lang";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

function ModifyTemplate(props) {
	const navigate = useNavigate();
	let { id } = useParams();
	const [templateId, setTemplateId] = useState(0);
	const [loading, setLoading] = useState(false);
	const [breadcrumbs, setBreadcrumbs] = useState([]);
	const [folderId, setFolderId] = useState(0);
	const [allSenders, setAllSenders] = useState([]);
	const [selectedSenders, setSelectedSenders] = useState([]);
	const [envelopeName, setEnvelopeName] = useState('');
	const [clientMessage, setClientMessage] = useState('');
	const [subject, setSubject] = useState('');
	const [emailText, setEmailText] = useState('');
	const [documentList, setDocumentList] = useState([]);
	const [requestFormList, setRequestFormList] = useState([]);
	const [removeDocumentsId, setRemoveDocumentsId] = useState([]);
	const [removeRequestFormId, setRemoveRequestFormId] = useState([]);
	const [templateData, setTemplateData] = useState({});

	const animatedComponents = makeAnimated();

	const [nameConvention, setNameConvention] = useState(1);
	const [syncStatusList, setSyncStatusList] = useState(SYNC_STATUS);
	const [cloudSync, setCloudSync] = useState(0);
	const [sendReminder, setSendReminder] = useState(0);
	const [overdueReminder, setOverdueReminder] = useState(0);
	const [isPassword, setIsPassword] = useState(0);
	const [password, setPassword] = useState('');
	const [referenceId, setReferenceId] = useState('');

	let docObj = {
		type: 'create',
		id: 0,
		name: '',
		detail: '',
		files: [],
		date_format: 0,
		remove_doc_id: []
	};
	const [docData, setDocData] = useState(docObj);

	let formObj = {
		type: 'create',
		id: 0,
		name: '',
		questions: [],
		remove_question_ids: [],
		remove_option_ids: []
	};
	const [formData, setFormData] = useState(formObj);

	let errorsObj = {
		sender_id: '',
		envelope_name: '',
		client_message: '',
		documents: '',
		request_form: '',
		subject: '',
		email_text: '',
		password: '',
	};
	const [errors, setErrors] = useState(errorsObj);

	const openDocumentRef = useRef(null);
	const docDragItem = useRef(null);
	const docDragOverItem = useRef(null);
	const openRequestFormRef = useRef(null);
	const formDragItem = useRef(null);
	const formDragOverItem = useRef(null);

	useEffect(function () {
		setLoading(true);
		getTemplateUser({})
			.then(responseData => {
				let sList = responseData.data.data;
				let selectedSenderList = [];
				for (let i = 0; i < sList.length; i++) {
					selectedSenderList.push({
						value: parseInt(sList[i]['id']),
						label: sList[i]['first_name'] + ' ' + sList[i]['last_name']
					});
				}
				setAllSenders(selectedSenderList);

				if (id) {
					if (props.type === 1) {
						postCloudList({})
							.then(response => {
								setSyncStatusList(response.data.data);

								getPreferenceData({})
									.then(response => {
										let preferenceData = response.data.data;
										setClientMessage(preferenceData.client_portal_message);
										setSubject(preferenceData.email_subject);
										setEmailText(preferenceData.email_message);
										setSendReminder(parseInt(preferenceData.recipient_send_reminder_type));
										setOverdueReminder(parseInt(preferenceData.recipient_overdue_reminder_type));
										if (parseInt(preferenceData.default_cloud_storage) > 0) {
											setCloudSync(parseInt(preferenceData.default_cloud_storage));
										}
									})
									.catch(err => {

									});
							})
							.catch(err => {

							});

						templateFolderBreadcrumbs({ uuid: id })
							.then(response => {
								setFolderId(response.data.data.id);
								setBreadcrumbs(response.data.breadcrumbs);
								setLoading(false);
							})
							.catch(err => {
								navigate('/templates');
								toast.error(Utils.getErrorMessage(err));
								setLoading(false);
							});
					} else {
						getTemplateEnvelope({ uuid: id })
							.then(response => {
								setTemplateId(parseInt(response.data.data.id));
								setFolderId(parseInt(response.data.data.folder_id));
								setBreadcrumbs(response.data.breadcrumbs);
								setEnvelopeName(response.data.data.envelope_name);
								setClientMessage(response.data.data.message);
								setSubject(response.data.data.email_subject);
								setEmailText(response.data.data.email_text);
								setDocumentList(response.data.data.document_list);
								setRequestFormList(response.data.data.request_form_list);
								setNameConvention((response.data.data.name_convention) ? parseInt(response.data.data.name_convention) : 1);
								setCloudSync((response.data.data.cloud_sync) ? parseInt(response.data.data.cloud_sync) : 0);
								setSendReminder((response.data.data.send_reminder) ? parseInt(response.data.data.send_reminder) : 0);
								setOverdueReminder((response.data.data.over_due_reminder) ? parseInt(response.data.data.over_due_reminder) : 0);
								if (response.data.data.password) {
									setIsPassword(1);
									setPassword(response.data.data.password);
								} else {
									setIsPassword(0);
								}
								setReferenceId((response.data.data.reference_id) ? response.data.data.reference_id : '');
								setTemplateData(response.data.data);

								let selectedSList = [];
								if (response.data.data.share_user_ids) {
									for (let i = 0; i < sList.length; i++) {
										let index = response.data.data.share_user_ids.findIndex(x => parseInt(x) === parseInt(sList[i]['id']));
										if (index > -1) {
											selectedSList.push({
												value: parseInt(sList[i]['id']),
												label: sList[i]['first_name'] + ' ' + sList[i]['last_name']
											});
										}
									}
								}
								setSelectedSenders(selectedSList);
								setLoading(false);
							})
							.catch(err => {
								navigate('/templates');
								toast.error(Utils.getErrorMessage(err));
								setLoading(false);
							});
					}
				} else {
					postCloudList({})
						.then(response => {
							setSyncStatusList(response.data.data);

							getPreferenceData({})
								.then(response => {
									let preferenceData = response.data.data;
									setClientMessage(preferenceData.client_portal_message);
									setSubject(preferenceData.email_subject);
									setEmailText(preferenceData.email_message);
									setSendReminder(parseInt(preferenceData.recipient_send_reminder_type));
									setOverdueReminder(parseInt(preferenceData.recipient_overdue_reminder_type));
									if (parseInt(preferenceData.default_cloud_storage) > 0) {
										setCloudSync(parseInt(preferenceData.default_cloud_storage));
									}
									setLoading(false);
								})
								.catch(err => {
									setLoading(false);
								});
						})
						.catch(err => {
							setLoading(false);
						});
				}
			})
			.catch(err => {
				setLoading(false);
				navigate('/templates');
				toast.error(Utils.getErrorMessage(err));
			});
	}, [id, navigate, props]);

	const docDragStart = (e, position) => {
		docDragItem.current = position;
	};

	const docDragEnter = (e, position) => {
		docDragOverItem.current = position;
	};

	const docDrop = (e) => {
		const copyListItems = [...documentList];
		const dragItemContent = copyListItems[docDragItem.current];
		copyListItems.splice(docDragItem.current, 1);
		copyListItems.splice(docDragOverItem.current, 0, dragItemContent);
		docDragItem.current = null;
		docDragOverItem.current = null;
		setDocumentList(copyListItems);
	};

	const formDragStart = (e, position) => {
		formDragItem.current = position;
	};

	const formDragEnter = (e, position) => {
		formDragOverItem.current = position;
	};

	const formDrop = (e) => {
		const copyListItems = [...requestFormList];
		const dragItemContent = copyListItems[formDragItem.current];
		copyListItems.splice(formDragItem.current, 1);
		copyListItems.splice(formDragOverItem.current, 0, dragItemContent);
		formDragItem.current = null;
		formDragOverItem.current = null;
		setRequestFormList(copyListItems);
	};

	const onBackTemplate = (e) => {
		e.preventDefault();
		navigate('/templates');
	};

	const handleDocumentImport = (e) => {
		const file = e.target.files[0];
		if (!file) return;

		const reader = new FileReader();

		reader.onload = (event) => {
			try {
				let documents = [];
				const content = event.target.result;

				if (file.name.endsWith('.csv')) {
					const lines = content.split('\n');
					const headers = lines[0].split(',').map(h => h.trim());

					for (let i = 1; i < lines.length; i++) {
						if (!lines[i].trim()) continue;

						const values = lines[i].split(',');
						const document = {
							id: 0,
							name: values[0] || '',
							detail: values[1] || '',
							files: [],
							date_format: parseInt(values[2]) || 0,
							remove_doc_id: []
						};
						documents.push(document);
					}
				} else if (file.name.endsWith('.json')) {
					documents = JSON.parse(content);
				}

				setDocumentList([...documentList, ...documents]);
			} catch (error) {
				toast.error('Error parsing document file: ' + error.message);
			}
		};

		if (file.name.endsWith('.csv')) {
			reader.readAsText(file);
		} else if (file.name.endsWith('.json')) {
			reader.readAsText(file);
		} else {
			toast.error('Unsupported file format');
		}

		e.target.value = '';
	};

	const handleDownloadSampleDocCSV = () => {
		const csvContent = `Document name, Document description ,date_format(0:no expiry | 1:DD/MM/YYYY | 2:MM/DD/YYYY | 3:MM/YYYY) 
	Tax Return Form,Please upload your completed tax return form,0
	ID Proof,Upload a valid government-issued ID,1
	Financial Statement,Provide your latest financial statement,2
	Contract Agreement,Upload the signed contract document,3`;

		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.setAttribute('href', url);
		link.setAttribute('download', 'sample_document_template.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	const handleQuestionImport = (e) => {
		const file = e.target.files[0];
		if (!file) return;

		const reader = new FileReader();

		reader.onload = (event) => {
			try {
				let questions = [];
				const content = event.target.result;

				if (file.name.endsWith('.csv')) {
					const lines = content.split('\n');
					const headers = lines[0].split(',').map(h => h.trim());

					for (let i = 1; i < lines.length; i++) {
						if (!lines[i].trim()) continue;

						const values = lines[i].split(',');
						const question = {
							type: parseInt(values[0]) || 1,
							name: values[1] || '',
							sub_label: values[2] || '',
							// Special handling for options
							options: [3, 4, 5].includes(parseInt(values[0]))
								? (values[3] ? values[3].split('|').map(opt => ({ id: 0, name: opt.trim() })) : [])
								: [],
							is_show: false,
							id: 0
						};
						questions.push(question);
					}
				}
				else if (file.name.endsWith('.json')) {
					questions = JSON.parse(content);
				}

				// Create a new form with imported questions
				const newForm = {
					type: 'create',
					id: 0,
					name: `Imported Form ${requestFormList.length + 1}`,
					questions: questions,
					remove_question_ids: [],
					remove_option_ids: []
				};

				setFormData(newForm);
				openRequestFormRef?.current.click();

			} catch (error) {
				toast.error('Error parsing file: ' + error.message);
			}
		};

		if (file.name.endsWith('.csv')) {
			reader.readAsText(file);
		} else if (file.name.endsWith('.xlsx')) {
			reader.readAsText(file);
		} else if (file.name.endsWith('.json')) {
			reader.readAsText(file);
		} else {
			toast.error('Unsupported file format');
		}

		// Reset file input
		e.target.value = '';
	};
	const handleEditDoc = (e, data) => {
		e.preventDefault();
		let obj = {
			type: 'edit',
			id: data.id,
			name: data.name,
			detail: data.detail,
			files: data.files,
			date_format: data.date_format,
			remove_doc_id: data.remove_doc_id
		};
		setDocData(obj);
		openDocumentRef?.current.click();
	};

	// Inside ModifyTemplate component
	const handleDownloadSampleCSV = () => {
		const csvContent = `type(1 = Short Text | 2 = Long Text | 3 = Dropdown | 4 = Single Choice | 5 = Multiple Choice | 6 = File Upload | 7 = Content Block | 8 = Date,name,sub_label,options
	1,Client Name,Enter your full name,
	2,Project Description,Provide a detailed description of your project,
	3,Preferred Contact Method,Select your preferred contact method,Email|Phone|In-Person
	4,Urgency Level,How urgent is your request?,Low|Medium|High
	5,Required Documents,Select all documents you can provide,Passport|Driver's License|Utility Bill
	6,Proof of Identity,Upload a valid ID document,
	7,Instructions,Please complete all fields accurately to process your request,
	8,Preferred Meeting Date,Select a date for your consultation,`;

		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.setAttribute('href', url);
		link.setAttribute('download', 'sample_form_template.csv');
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	};

	const handleCopyDoc = (e, data) => {
		e.preventDefault();
		let obj = {
			type: 'create',
			id: 0,
			name: data.name,
			detail: data.detail,
			files: [],
			date_format: data.date_format,
			remove_doc_id: []
		};
		setDocData(obj);
		openDocumentRef?.current.click();
	};

	const handleDeleteDoc = (e, index) => {
		let docList = [...documentList];
		let docId = docList[index]['id'];
		if (docId > 0) {
			let removeIds = [...removeDocumentsId];
			removeIds.push(docId);
			setRemoveDocumentsId(removeIds);
		}

		docList.splice(index, 1);

		setDocumentList(docList);
	};

	const handleEditRequestForm = (e, data) => {
		e.preventDefault();
		let obj = {
			type: 'edit',
			id: data.id,
			name: data.name,
			questions: data.questions,
			remove_question_ids: data.remove_question_ids,
			remove_option_ids: data.remove_option_ids
		};
		setFormData(obj);
		openRequestFormRef?.current.click();
	};

	const handleCopyRequestForm = (e, data) => {
		e.preventDefault();

		let questions = data.questions;
		let list = [];
		for (let i = 0; i < questions.length; i++) {
			let options = [];
			for (let j = 0; j < questions[i]['options'].length; j++) {
				options.push({
					id: 0,
					name: questions[i]['options'][j]['name']
				});
			}
			list.push({
				id: 0,
				is_show: false,
				name: questions[i]['name'],
				options: options,
				select_options: questions[i]['select_options'],
				sub_label: questions[i]['sub_label'],
				type: questions[i]['type']
			});
		}

		let obj = {
			type: 'create',
			id: 0,
			name: data.name,
			questions: list,
			remove_question_ids: [],
			remove_option_ids: []
		};
		setFormData(obj);
		openRequestFormRef?.current.click();
	};

	const handleDeleteRequestForm = (e, index) => {
		let formList = [...requestFormList];

		let formId = formList[index]['id'];
		if (formId > 0) {
			let removeIds = [...removeRequestFormId];
			removeIds.push(formId);
			setRemoveRequestFormId(removeIds);
		}

		formList.splice(index, 1);
		setRequestFormList(formList);
	};

	const handleClearTemplate = (e) => {
		e.preventDefault();

		if (templateId > 0) {
			let data = { ...templateData };

			let senderList = [];
			if (data.share_user_ids) {
				let sList = [...allSenders];
				for (let i = 0; i < sList.length; i++) {
					let index = data.share_user_ids.findIndex(x => parseInt(x) === parseInt(sList[i]['value']));
					if (index > -1) {
						senderList.push(sList[i]);
					}
				}
			}
			setSelectedSenders(senderList);

			setEnvelopeName(data.envelope_name);
			setClientMessage(data.message);
			setSubject(data.email_subject);
			setEmailText(data.email_text);
			setDocumentList(data.document_list);
			setRequestFormList(data.request_form_list);
			setRemoveDocumentsId([]);
			setRemoveRequestFormId([]);
		} else {
			setSelectedSenders([]);
			setEnvelopeName('');
			setClientMessage('');
			setSubject('');
			setEmailText('');
			setDocumentList([]);
			setRequestFormList([]);
		}
		setErrors(errorsObj);
	};

	const handleTemplate = async (e) => {
		e.preventDefault();
		let error = false;
		let totalKb = 0;
		let errorObj = { ...errorsObj };

		if (selectedSenders.length === 0) {
			errorObj.sender_id = 'Please select one';
			error = true;
		}
		if (!envelopeName) {
			errorObj.envelope_name = 'Please enter name';
			error = true;
		}
		if (!clientMessage) {
			errorObj.client_message = 'Please enter message';
			error = true;
		}
		if (documentList.length === 0) {
			errorObj.documents = 'Please add at-least one document';
			error = true;
		}
		if (!subject) {
			errorObj.subject = 'Please enter subject';
			error = true;
		}
		if (!emailText) {
			errorObj.email_text = 'Please enter email text';
			error = true;
		}
		if (parseInt(isPassword) === 1 && !password) {
			errorObj.password = 'Please enter password';
			error = true;
		}

		setErrors(errorObj);

		if (error) return;

		setLoading(true);

		let senderIds = selectedSenders.map(x => x.value);

		const formData = new FormData();
		formData.append('id', templateId);
		formData.append('folder_id', folderId);
		formData.append('sender_id', JSON.stringify(senderIds));
		formData.append('envelope_name', envelopeName);
		formData.append('client_message', clientMessage);
		formData.append('subject', subject);
		formData.append('email_text', emailText);
		for (let i = 0; i < documentList.length; i++) {
			let docData = documentList[i];
			formData.append('doc_id[' + i + ']', docData.id);
			formData.append('doc_name[' + i + ']', docData.name);
			formData.append('doc_detail[' + i + ']', docData.detail);
			for (let j = 0; j < docData.files.length; j++) {
				formData.append('doc_files[' + i + ']', docData.files[j]['file']);
				totalKb += parseFloat(docData.files[j]["kb"]);
			}
			formData.append('date_format[' + i + ']', docData.date_format);
			formData.append('remove_doc_file_id[' + i + ']', JSON.stringify(docData.remove_doc_id));
		}
		formData.append('request_form', JSON.stringify(requestFormList));
		formData.append('remove_doc_id', JSON.stringify(removeDocumentsId));
		formData.append('remove_form_id', JSON.stringify(removeRequestFormId));
		formData.append('name_convention', nameConvention);
		formData.append('cloud_sync', cloudSync);
		formData.append('send_reminder', sendReminder);
		formData.append('overdue_reminder', overdueReminder);
		formData.append('reference_id', referenceId);
		if (parseInt(isPassword) === 1) {
			formData.append('password', password);
		} else {
			formData.append('password', '');
		}

		let isCall = true;
		if (totalKb > 0) {
			isCall = false;
			await getEnvelopeDocumentCheckStorage({ kb: totalKb })
				.then((res) => {
					if (res.data.is_storage_full === false) {
						isCall = true;
					} else {
						toast.error(res.data.message);
						props.setLoading(false);
					}
				}).catch(err => {
					props.setLoading(false);
					toast.error(Utils.getErrorMessage(err));
				});
		}

		if (isCall === true) {
			templateEnvelopeModify(formData)
				.then(response => {
					setLoading(false);
					toast.success(response.data.message);
					navigate('/templates');
				})
				.catch(err => {
					setLoading(false);
					toast.error(Utils.getErrorMessage(err));
				});
		}
	};

	const handlePassword = (e) => {
		setIsPassword(e.target.value);
		setPassword('');
	};

	return (
		<>
			{loading && <div className="page-loading">
				<img src="/images/loader.gif" alt="loader" />
			</div>}
			<div className="templates_page">
				<section className="main_wrapper section-bg-color sleeve-gradient-bg
" style={{ minHeight: 'calc(100vh - 0px)' }}>
					<div className="container" style={{ marginTop: "8vh" }}>
						<h2 className="modify-template-title text-white mb-3 d-flex align-items-center justify-content-between bread_crumb flexWrap">
							<span>
								{breadcrumbs.length === 0 ?
									<span>
										<i className="bi bi-folder-fill" aria-hidden="true" /> My Templates
									</span>
									:
									<>
										<span className="">
											<i className="bi bi-folder-fill" aria-hidden="true" /> My Templates
										</span>
										{breadcrumbs.map((item, index) =>
											<React.Fragment key={index}>
												<i className="bi bi-chevron-double-right mx-3" />
												<span className={`${item.is_last === true ? `` : `text_blue`}`}>
													<i className="bi bi-folder-fill"
														aria-hidden="true" /> {item.folder_name}
												</span>
											</React.Fragment>
										)}
									</>
								}
							</span>
							<div className="d-flex">
								<button type="button" className="modern-back-btn ms-2 d-flex align-items-center"
									data-toggle="tooltip" data-placement="right" title="Click me to back"
									onClick={onBackTemplate}>
									<i className="bi bi-arrow-left me-2" aria-hidden="true" />Back
								</button>
							</div>
						</h2>
						<div className="text-white py-2">
							<h2>{props.type === 1 ? `Create a Template` : `Edit Template`}</h2>
							<p className="mb-2">Build and customize your document request template</p>
						</div>

						<div>
							{/*1. Template Directory */}
							<div className="modify-template-card">
								<h2 className="modify-template-card-title">
									<span className="round_blue me-2">1</span>Template Directory
								</h2>
								<div className="mb-0">
									<label className="form-label modify-template-card-label">Share with
										<i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
											data-toggle="tooltip" data-placement="right"
											title="Share this template with users" />
									</label>
									<Select closeMenuOnSelect={true} value={selectedSenders}
										components={animatedComponents} isMulti
										onChange={(e) => setSelectedSenders(e)}
										options={allSenders} />
									{errors.sender_id &&
										<div className="text-danger mt-2">{errors.sender_id}</div>}
								</div>

							</div>

							{/* 2. Sleeve Details */}
							<div className="modify-template-card">
								<h2 className="modify-template-card-title">
									<span className="round_blue me-2">2</span>Sleeve Details
								</h2>
								<div>
									<div className="row">
										<div className="col-md-12">
											<div className="mb-4">
												<label className="form-label modify-template-card-label">Request Title / Folder Name (Sleeve Name)
													<i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
														data-toggle="tooltip" data-placement="right"
														title={Lang.env_envelope_name} />
												</label>
												<input type="text" className="form-control" value={envelopeName}
													onChange={(e) => setEnvelopeName(e.target.value)}
													aria-describedby="emailHelp"
													placeholder="Enter sleeves Name" />
												{errors.envelope_name &&
													<div className="text-danger mt-2">{errors.envelope_name}</div>}
											</div>
										</div>
										<div className="col-md-12">
											<div className="mb-0">
												<label className="form-label modify-template-card-label">Client Portal Message
													<i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
														data-toggle="tooltip" data-placement="right"
														title={Lang.env_client_message} />
												</label>
												<textarea className="form-control" rows={9} value={clientMessage}
													onChange={(e) => setClientMessage(e.target.value)}
													placeholder="Enter Message to Client" />
												{errors.client_message &&
													<div className="text-danger mt-2">{errors.client_message}</div>}
											</div>
										</div>
									</div>
								</div>
							</div>

							{/* 3. Email Details */}
							<div className="modify-template-card">
								<h2 className="modify-template-card-title">
									<span className="round_blue me-2">3</span>Email Details
								</h2>
								<div>
									<div className="mb-4">
										<label htmlFor="email_subject" className="form-label modify-template-card-label">Subject
											<i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
												data-toggle="tooltip" data-placement="right"
												title={Lang.env_subject} />
										</label>
										<input type="text" className="form-control" id="email_subject"
											value={subject} onChange={(e) => setSubject(e.target.value)}
											aria-describedby="emailHelp" placeholder="Enter Email Subject" />
										{errors.subject && <div className="text-danger mt-2">{errors.subject}</div>}
									</div>
									<div className="mb-4">
										<label htmlFor="email_text" className="form-label modify-template-card-label">Email Text
											<i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
												data-toggle="tooltip" data-placement="right"
												title={Lang.env_email_text} />
										</label>
										<textarea className="form-control" rows={12} value={emailText}
											onChange={(e) => setEmailText(e.target.value)}
											placeholder="Enter Email text box" />
										{errors.email_text &&
											<div className="text-danger mt-2">{errors.email_text}</div>}
									</div>
								</div>
							</div>

							{/* 4. Document Request */}
							<div className="modify-template-card">
								<div className="modify-template-card-section">
									<h2 className="modify-template-card-title">
										<span className="round_blue me-2 mb-2
										">4</span>Document Request
									</h2>
									<div className="d-flex flex_wrap gap-3">
										<button type="button" className="modify-template-import-button "
											data-toggle="tooltip" data-bs-original-title="Upload a CSV file to import document requests."
											onClick={() => document.getElementById('importDocuments').click()}>
											<i className="bi bi-upload me-2"></i>Import
										</button>
										<button type="button" className="modify-template-import-button "
											onClick={handleDownloadSampleDocCSV}
											data-toggle="tooltip" data-bs-original-title="Download a sample CSV to see the format for importing document requests.">
											<i className="bi bi-download me-2"></i>Download
										</button>
										<button type="button" className="modify-create-btn "
											data-bs-toggle="offcanvas" data-bs-target="#Add-document"
											aria-controls="Add-document" data-toggle="tooltip"
											ref={openDocumentRef} data-placement="right" title=""
											data-bs-original-title="Add Document into the Sleeves for which you required to collect Document">
											<span className="me-3">+</span>Add Request
										</button>
										<input
											type="file"
											id="importDocuments"
											style={{ display: 'none' }}
											accept=".csv,.json"
											onChange={handleDocumentImport}
										/>
									</div>
								</div>
								<div className="">
									{documentList.length === 0 ? (
										<div className="modify-empty-state text-center py-5">
											<i className="bi bi-file-earmark-text mb-3" style={{ fontSize: 64, color: "#c3c7ce" }}></i>
											<div className="fw-bold fs-4 text-muted">No document requests have been configured yet</div>
											<div className="text-muted">Upload documents request or add a custom request to get started.</div>
										</div>
									) : (
										documentList.map((item, index) =>
											<h2 key={index} className="request_document_tab "
												onClick={(e) => handleEditDoc(e, item)}
												data-toggle="tooltip"
												data-placement="right" title="Click to View Document Request">
												<div className="d-flex justify-content-between">
													<div className="accordion_text" style={{ cursor: "grab" }}
														onDragStart={(e) => docDragStart(e, index)}
														onDragEnter={(e) => docDragEnter(e, index)}

														onDragEnd={docDrop} draggable>
														<img src="/images/dots_rectangle.webp" alt="..."
															className="me-3" />
														{item.name}
													</div>
													<div className="functional_icon_ellipsis">
														{/* <span className="functional_icon_round cursor-pointer"
															data-toggle="tooltip" data-placement="right" title=""
															data-bs-original-title="click Me">
															<i className="bi bi-people-fill" aria-hidden="true" />
														</span> */}
														<div className="dropdown">
															<span className="functional_icon_ellipsis cursor-pointer"
																id="dropdownMenuButton1" data-bs-toggle="dropdown"
																aria-expanded="false" onClick={e => {
																	e.stopPropagation();

																}}>
																<i className="bi bi-three-dots-vertical" />
															</span>
															<ul className="dropdown-menu"
																aria-labelledby="dropdownMenuButton1">
																<li onClick={(e) => { e.stopPropagation(); handleEditDoc(e, item) }}>
																	<span className="dropdown-item">
																		<i className="bi bi-pencil-fill me-2"
																			aria-hidden="true" /> Edit
																	</span>
																</li>
																<li onClick={(e) => { e.stopPropagation(); handleCopyDoc(e, item) }}>
																	<span className="dropdown-item">
																		<i className="bi bi-copy me-2"
																			aria-hidden="true" /> Duplicate
																	</span>
																</li>
																<li onClick={(e) => { e.stopPropagation(); handleDeleteDoc(e, index) }}>
																	<span className="dropdown-item">
																		<i className="bi bi-trash  me-2"
																			aria-hidden="true" />Delete
																	</span>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</h2>
										)
									)}
									{errors.documents && <div className="text-danger mt-2">{errors.documents}</div>}
								</div>
							</div>

							{/* 5. Information Request (Form Builder) */}
							<div className="modify-template-card">
								<div className="modify-template-card-section">
									<h2 className="modify-template-card-title">
										<span className="round_blue me-2">5</span>Information Request <br /> (Form Builder)
									</h2>
									<div className="d-flex flex_wrap gap-3">
										<button type="button" className="modify-template-import-button "
											data-toggle="tooltip" data-bs-original-title="Upload a CSV file to import questions into your form."
											onClick={() => document.getElementById('importQuestions').click()}>
											<i className="bi bi-upload me-2"></i>Import
										</button>
										<button type="button" className="modify-template-import-button "
											onClick={handleDownloadSampleCSV}
											data-toggle="tooltip" data-bs-original-title="Download a sample CSV to see the format for importing questions.">
											<i className="bi bi-download me-2"></i>Download
										</button>
										<button type="button" className="modify-create-btn"
											data-bs-toggle="offcanvas" data-bs-target="#MakeForm"
											aria-controls="MakeForm" data-toggle="tooltip"
											ref={openRequestFormRef}
											data-placement="right" title="" data-bs-original-title="Add Question into the Sleeves for which you required to collect Data.">
											<span className="me-3">+</span>Create a Form
										</button>
										<input
											type="file"
											id="importQuestions"
											style={{ display: 'none' }}
											accept=".csv,.xlsx,.json"
											onChange={handleQuestionImport}
										/>
									</div>
								</div>
								<div className="">
									{requestFormList.length === 0 ? (
										<div className="modify-empty-state text-center py-5">
											<i className="bi bi-file-earmark-text mb-3" style={{ fontSize: 64, color: "#c3c7ce" }}></i>
											<div className="fw-bold fs-4 text-muted">No information requests have been configured yet</div>
											<div className="text-muted">Create a form to start collecting information from users</div>
										</div>
									) : (
										requestFormList.map((item, index) =>
											<h2 key={index} className="request_document_tab yellow" onClick={(e) => handleEditRequestForm(e, item)} data-toggle="tooltip"
												data-placement="right" title="Click to View Information Request">
												<div className="d-flex justify-content-between">
													<div className="accordion_text" style={{ cursor: "grab" }}
														onDragStart={(e) => formDragStart(e, index)}
														onDragEnter={(e) => formDragEnter(e, index)}

														onDragEnd={formDrop} draggable>

														<img src="/images/dots_rectangle.webp" alt="..."
															className="me-3" />{item.name}
													</div>
													<div className="functional_icon_ellipsis">
														{/* <span className="functional_icon_round"
															data-toggle="tooltip" data-placement="right" title=""
															data-bs-original-title="click Me">
															<i className="bi bi-people-fill" aria-hidden="true" />
														</span> */}
														<div className="dropdown">
															<span className="functional_icon_ellipsis cursor-pointer"
																id="dropdownMenuButton1" data-bs-toggle="dropdown"
																aria-expanded="false" onClick={e => {
																	e.stopPropagation();
																}}>
																<i className="bi bi-three-dots-vertical" />
															</span>
															<ul className="dropdown-menu"
																aria-labelledby="dropdownMenuButton1">
																<li onClick={(e) => { e.stopPropagation(); handleEditRequestForm(e, item) }}>
																	<span className="dropdown-item">
																		<i className="bi bi-pencil-fill me-2"
																			aria-hidden="true" /> Edit
																	</span>
																</li>
																<li onClick={(e) => { e.stopPropagation(); handleCopyRequestForm(e, item) }}>
																	<span className="dropdown-item">
																		<i className="bi bi-copy me-2"
																			aria-hidden="true" /> Duplicate
																	</span>
																</li>
																<li onClick={(e) => { e.stopPropagation(); handleDeleteRequestForm(e, index) }}>
																	<span className="dropdown-item">
																		<i className="bi bi-trash  me-2"
																			aria-hidden="true" />Delete
																	</span>
																</li>
															</ul>
														</div>
													</div>
												</div>
											</h2>
										)
									)}
									{errors.request_form &&
										<div className="text-danger mt-2">{errors.request_form}</div>}
								</div>
							</div>

							{/* 6. More Settings */}
							<div className="modify-template-card p-4">
								<h2 className="modify-template-card-title">
									<span className="round_blue me-2">6</span>More Settings
								</h2>
								<div className="row gy-4">
									<div className="col-md-6">
										<label className="form-label modify-template-card-label" >Naming Convention <i className="bi bi-info-circle ms-1 cur-pointer" data-toggle="tooltip" title={Lang.env_naming_convention} /></label>
										<select className="form-select" value={nameConvention} onChange={(e) => setNameConvention(e.target.value)}>
											{NAME_CONVENTION.map((item, index) => (
												<option key={index} value={item.id}>{item.value}</option>
											))}
										</select>
									</div>
									<div className="col-md-6">
										<label className="form-label modify-template-card-label" >Cloud Storage Sync <i className="bi bi-info-circle ms-1 cur-pointer" data-toggle="tooltip" title={Lang.env_cloud_sync} /></label>
										<select className="form-select" value={cloudSync} onChange={(e) => setCloudSync(e.target.value)}>
											{syncStatusList.map((item, index) => (
												<option key={index} value={item.id}>{item.value}</option>
											))}
										</select>
									</div>
									<div className="col-md-6">
										<label className="form-label modify-template-card-label" >Send Reminder (Email) <i className="bi bi-info-circle ms-1 cur-pointer" data-toggle="tooltip" title={Lang.env_send_reminder} /></label>
										<select className="form-select" value={sendReminder} onChange={(e) => setSendReminder(e.target.value)}>
											{SEND_REMINDER.map((item, index) => (
												<option key={index} value={item.id}>{item.value}</option>
											))}
										</select>
									</div>
									<div className="col-md-6">
										<label className="form-label modify-template-card-label" >Overdue Reminder (Email) <i className="bi bi-info-circle ms-1 cur-pointer" data-toggle="tooltip" title={Lang.env_overdue_reminder} /></label>
										<select className="form-select" value={overdueReminder} onChange={(e) => setOverdueReminder(e.target.value)}>
											{OVERDUE_REMINDER.map((item, index) => (
												<option key={index} value={item.id}>{item.value}</option>
											))}
										</select>
									</div>
									<div className="col-md-12">
										<label className="form-label modify-template-card-label" >Reference ID <i className="bi bi-info-circle ms-1 cur-pointer" data-toggle="tooltip" title={Lang.env_reference} /></label>
										<input type="text" value={referenceId} onChange={(e) => setReferenceId(e.target.value)} className="form-control" placeholder="Enter Reference ID" />
									</div>
									{/* Password fields remain hidden as before */}
									{isPassword > 0 && (
										<div className="col-md-6">
											<label className="form-label modify-template-card-label" >Password</label>
											<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" placeholder="Enter password" />
											{errors.password && <div className="text-danger ms-2">{errors.password}</div>}
										</div>
									)}
								</div>
							</div>
						</div>

						<div className="gradient-btn-group">
							<button
								type="button"
								className="gradient-btn gradient-btn-outline"
								onClick={onBackTemplate}
							>
								Cancel
							</button>
							<button
								type="button"
								className="gradient-btn gradient-btn-primary"
								onClick={handleTemplate}
							>
								{props.type === 1 ? `Create Template` : `Save Template`}
							</button>
						</div>
					</div>
				</section>
			</div>

			<DocumentTemplate docData={docData} setDocData={setDocData} documentList={documentList}
				setDocumentList={setDocumentList} setLoading={setLoading} />

			<RequestFormTemplate formData={formData} setFormData={setFormData} requestFormList={requestFormList}
				setRequestFormList={setRequestFormList} />
		</>
	);
}

export default ModifyTemplate;

